import React from "react";

const SharedIcon = ({ title, ...props }) => (
  <svg
    version="1.1"
    viewBox="0 0 1186 406.9"
    style={{ enableBackground: "new 0 0 1186 406.9" }}
    {...props}
  >
    {title ? <title>{title}</title> : null}
    <g>
      <path
        d="M1182,335.7c-14.6,0-29.1,0-44.2,0c-1-8.4-2-16.7-3.1-25.5c-0.7,0.8-1,1.1-1.3,1.5
  		c-11.6,16.4-27.8,25.2-47.4,27.6c-20.3,2.6-40-0.1-58.6-8.9c-25.2-11.9-41.2-31.8-48.4-58.5c-6.4-23.6-6-47.3,1.4-70.6
  		c10.8-34,34.7-53.5,69.4-60.3c20.2-3.9,39.8-2.2,58.6,6.7c10,4.7,18.9,10.8,25.2,20.1c0.1,0.2,0.5,0.3,1,0.7c0-35,0-69.7,0-104.8
  		c16,0,31.6,0,47.3,0C1182,154.4,1182,245,1182,335.7z M1072.1,183.7c-17.8,0.6-34.7,9.6-44.4,30.1c-4.9,10.4-6.1,21.6-4.9,33.1
  		c4.2,39.3,42,58.6,75.7,44.7c20.1-8.4,30.3-24.4,32.8-45.8C1135.2,212.1,1110.1,183.7,1072.1,183.7z"
      />
      <path
        d="M236.8,62.4c0,34.2,0.1,68.4,0.1,102.7c0,1.1,0,2.2,0,4c1.5-1.8,2.6-2.9,3.6-4.1
  		c13.2-15.1,29.9-22.9,49.8-24.1c14.2-0.8,28.1,0.6,41.2,6.4c19.7,8.7,31.2,24.4,37.5,44.3c4.3,13.6,5.8,27.6,5.8,41.8
  		c0,33,0,65.9,0,98.9c0,0.9-0.1,1.9-0.2,3c-15.7,0-31.2,0-47.3,0c0-1.3,0-2.6,0-4c0-31.8,0.1-63.6-0.1-95.4c0-6.7-0.7-13.6-2.3-20.2
  		c-5.8-24.4-25.1-32.4-45.3-30.6c-24.3,2.2-39.4,22.1-42.1,43.9c-0.5,3.8-0.6,7.7-0.6,11.6c0,30.1,0,60.3,0,90.4c0,1.3,0,2.7,0,4.3
  		c-15.8,0-31.4,0-47.3,0c-0.1-1.2-0.2-2.5-0.2-3.7c0-88.8,0-177.5,0-266.3c0-1,0.1-2.1,0.2-3.1C205.4,62.4,221.1,62.4,236.8,62.4z"
      />
      <path
        d="M81.5,342.6c-6.5-0.8-13.1-1.4-19.6-2.5c-22.1-3.9-40.8-14.2-56.4-30.1c-1-1-1.8-1.9-0.7-3.4
  		c7.4-10.7,14.7-21.4,22.1-32.3c0.6,0.4,1,0.6,1.3,0.9c19.3,17.3,42.3,25,67.8,25.7c8.6,0.2,16.8-2.4,23.7-7.9
  		c4-3.1,6.9-7.1,7.6-12.2c1.2-8.5-2.1-14.4-10.1-17.8c-8.9-3.9-18.5-4.3-28-5.1c-17.1-1.4-33.9-4.5-49.3-12.5
  		c-15.3-8-25.9-19.8-28.8-37.3c-4-24.2,5.8-44.7,27.1-57c12.5-7.3,26.2-11.1,40.6-12.3c18.5-1.7,36.9-0.6,54.6,5.4
  		c12.1,4.1,22.7,10.7,32.4,19.4c-8.8,10.4-17.5,20.7-26.3,31.2c-0.6-0.4-1.1-0.6-1.4-1c-12-11-26.5-15.9-42.5-15.9
  		c-7.7,0-15.4,1.3-23,2.3c-2.1,0.3-4.2,1.4-6.1,2.4c-5.6,2.9-9.2,7.3-9.3,13.8c-0.2,6.7,3,11.6,8.7,14.9c6.1,3.6,12.9,4.9,19.8,5.7
  		c13.1,1.7,26.2,2.8,39.2,5.2c7.1,1.3,14.1,4.1,20.7,7.2c19,9.2,28.3,25,29.1,45.7c1.2,29-14.4,51.2-42.9,61.3
  		c-9.1,3.3-18.6,5.1-28.2,5.8c-1,0.1-2.1,0.3-3.1,0.5C94.1,342.6,87.8,342.6,81.5,342.6z"
      />
      <path
        d="M962.5,256.6c-49.8,0-99.2,0-149.3,0c1.1,3.9,1.8,7.5,3.2,10.8c6.4,15.5,18.8,24,34.6,27.7
  		c21.2,5,41.4,1.8,60.5-8.3c3.6-1.9,6.7-4.6,10.1-6.9c9.7,9.9,19.5,19.9,29.6,30.2c-0.3,0.4-1.1,1.3-2,2.1
  		c-14,13.1-30.8,20.7-49.3,25c-23.3,5.4-46.6,5.2-69.5-2.1c-36.4-11.6-57.3-37.1-64.1-74.2c-3.7-20.1-2.9-40.1,4-59.5
  		c12.4-34.8,37.5-54.8,73.4-61.7c19.1-3.6,38.2-2.9,56.9,2.6c32.4,9.4,51.5,31.4,59.4,63.7c3.7,15.4,4,31.1,3,46.8
  		C963,253.9,962.7,255.1,962.5,256.6z M814.5,216.8c34.3,0,68.2,0,102.3,0c-0.1-0.9-0.1-1.6-0.2-2.2c-0.1-0.7-0.2-1.4-0.4-2.2
  		c-3.3-14.2-11.9-23.7-25.5-28.7c-10.5-3.9-21.5-4.7-32.5-3.1c-20.1,2.8-34.9,12.7-42.5,32.2C815.2,214,814.9,215.3,814.5,216.8z"
      />
      <path
        d="M667.7,335.6c-15.9,0-31.4,0-47.2,0c0-64,0-127.9,0-192c1.1-0.1,2.1-0.2,3.1-0.2c12.6,0,25.2,0,37.7-0.1
  		c2.3,0,3.1,0.6,3.3,2.9c0.8,6,1.9,12,2.9,18.3c0.6-0.6,1.1-0.8,1.3-1.2c10.4-15.8,25.3-23.6,43.9-24.8c17-1.1,33.2,1.6,48,10.5
  		c3.3,2,6.2,4.6,9.3,7c-1.4,3.5-2.6,7-4.3,10.3c-4.8,9.6-9.8,19.2-14.8,28.7c-0.5,0.9-1,1.8-1.7,2.9c-1.5-1.1-2.9-2.1-4.1-3.1
  		c-16.5-13.1-44.5-11.1-58.7-1.4c-11.2,7.6-16.5,18.6-18.1,31.6c-0.5,4.1-0.6,8.3-0.6,12.5c0,31.2,0,62.4,0,93.6
  		C667.7,332.5,667.7,333.9,667.7,335.6z"
      />
      <path
        d="M551.2,143.5c-0.5,8.4-1,16.7-1.6,25c-0.2,0.1-0.5,0.2-0.7,0.3c-0.2-0.4-0.4-0.8-0.6-1.1
  		c-8.5-12.7-20.6-20.3-34.8-24.9c-15.8-5.1-31.8-4.9-47.8-1.8c-34.6,6.6-59,25.9-70.7,59.6c-6.4,18.3-7.2,37.3-5,56.4
  		c2,17,7.2,32.8,16.8,47.1c23.9,35.2,73,43.7,103.7,33.8c13.9-4.5,26.3-11.4,35.3-23.4c1.2-1.6,2.3-3.4,3.8-5.7
  		c0.8,9.4,1.6,18.1,2.3,26.7c15.1,0,29.8,0,44.4,0c0-64.2,0-128,0-191.9C581.2,143.5,566.4,143.5,551.2,143.5z M548.4,246.2
  		c-0.7,7.8-2.7,15.3-6.3,22.2c-9.5,18.3-24.7,27.9-45.2,29.2c-23.1,1.5-46.3-9.1-55.7-33.4c-2.8-7.1-3.8-14.9-5.6-22.4
  		c0.3-0.1,0.6-0.1,0.9-0.2c-0.6-25.4,10.7-46.4,33-55.7c23-9.6,50.1-4.2,65.2,13.5C546.1,212.9,549.9,228.9,548.4,246.2z"
      />
    </g>
  </svg>
);

export default SharedIcon;
